<span class="its-plans__element-progresscount">
    <label for="{id}-elementprogresscount">
        <span class="screen-reader">{accessibleTextString}</span>
    </label>
    <span
        id="{id}-elementprogresscount"
        aria-hidden={validAccessibleTextString}
        class="its-plans__element-progresscountdata"
    >
        {doneCount}/{totalCount}
    </span>
</span>

<script>
    import { formatLanguageString } from "@itslearning/atlas/strings/format";

    $: accessibleTextString =
        accessibleText && formatLanguageString(accessibleText, doneCount, totalCount);
    $: validAccessibleTextString = accessibleTextString ? true : false;

    export let id = Math.random().toString(36).substring(2, 15);
    export let doneCount;
    export let totalCount;
    export let accessibleText;
</script>
